import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

import type { RealtimeClientProps } from './RealtimeClient';

const loader = () =>
  import(/* webpackChunkName: "4-feat-realtime" */ './RealtimeClient').then((module) => ({
    default: module.RealtimeClient,
  }));

export const LoadableRealtimeClient: ComponentType<RealtimeClientProps> = lazyLoadOnRender({ loader });
